import { create } from 'zustand';

export type UseUsersPaginationStore = {
  page: number;
  rowsPerPage: number;
  maxPage: number;
};

const defaultValue: UseUsersPaginationStore = {
  page: 1,
  rowsPerPage: 10,
  maxPage: 10,
};

const useUsersPaginationStore = create<UseUsersPaginationStore>(() => ({
  ...defaultValue,
}));

export const useUsersPage = () =>
  useUsersPaginationStore((state) => state.page);

export const useUsersRowsPerPage = () =>
  useUsersPaginationStore((state) => state.rowsPerPage);

export const useUsersMaxPage = () =>
  useUsersPaginationStore((state) => state.maxPage);

export const useUsersPagination = () =>
  useUsersPaginationStore((state) => state);

export const changeUsersPage = (page: number) =>
  useUsersPaginationStore.setState({ page });

export const changeUsersMaxPage = (maxPage: number) =>
  useUsersPaginationStore.setState({ maxPage });

export const changeUsersRowsPerPage = (rowsPerPage: number) =>
  useUsersPaginationStore.setState({ rowsPerPage, page: defaultValue.page });

export const resetUsersPage = () =>
  useUsersPaginationStore.setState({ page: defaultValue.page });

export const resetUsersStore = () =>
  useUsersPaginationStore.setState({ ...defaultValue });
